import {
  MealPlannerCategoryRow,
  MealPlannerFilters,
  MealPlannerPage,
  MealPlannerRecipeDetail,
  MealPlannerRecipeRow,
  MealPlannerStatus,
} from '@/Interfaces/I_mealPlanner';
import { customAxios } from '../index';

const BASE_URL = '/hktv_koc/cms/meal-planner';

export const getMealPlannerCategories = (params: MealPlannerFilters, signal?: AbortSignal) =>
  customAxios.get<MealPlannerPage<MealPlannerCategoryRow>>(`${BASE_URL}/categories`, {
    params,
    signal,
  });

export const getMealPlannerCategory = (id: string, signal?: AbortSignal) =>
  customAxios.get<MealPlannerCategoryRow>(`${BASE_URL}/categories/${encodeURIComponent(id)}`, {
    signal,
  });

export const getMealPlannerRecipes = (params: MealPlannerFilters, signal?: AbortSignal) =>
  customAxios.get<MealPlannerPage<MealPlannerRecipeRow>>(`${BASE_URL}/recipes`, { params, signal });

export const getMealPlannerRecipe = (id: string, signal?: AbortSignal) =>
  customAxios.get<{ recipe: MealPlannerRecipeDetail }>(
    `${BASE_URL}/recipes/${encodeURIComponent(id)}`,
    { signal },
  );

export const setMealPlannerStatus = (
  kind: 'categories' | 'recipes',
  id: string,
  disabled: boolean,
) =>
  customAxios.patch<MealPlannerStatus>(`${BASE_URL}/${kind}/${encodeURIComponent(id)}/status`, {
    disabled,
  });
